export default axios => ({
  /**
   * Удаляет площадку
   *
   * @param id
   * @returns {*}
   */
  delete (id) {
    return axios.delete(`/web/playground/get/${id}`)
  }
})
